import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className='container-fluid'>
        <div className='row'>
          
            <div className="footer-container">
              <div className="footer-section">
                <h3>GN Construction And Adviser Ltd.</h3>
                <p>Building excellence since 2010. We transform your vision into structures that stand the test of time.</p>
              </div>
              
              <div className="footer-section">
                <h4>Quick Links</h4>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/services">Services</Link></li>
                  <li><Link to="/projects">Projects</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </div>
              
              <div className="footer-section">
                <h4>Contact Us</h4>
                <p>Phone: 07853497378</p>
                <p>Phone: 07405395507</p>
                <p>Email: Gnconstruction70@gmail.com</p>
              </div>
            </div>
            
            <div className="footer-bottom">
              <p>&copy; {new Date().getFullYear()} GN Construction & Adviser Ltd. All Rights Reserved.</p>
            </div>
          </div>
        </div>
    </footer>
  );
};

export default Footer;